<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full bg-card">
  <div class="flex flex-col flex-auto w-full container-ael">
    <!-- Header -->
    <div class="px-30 header-container">
      <div class="logo-ael cursor-pointer" (click)="irRuta('/home')" (keydown)="onKey($event)">
        <img src="assets/images/logo/Logo_AEL.svg" alt="logo-ael" />
      </div>

      <div class="h-[63px]" style="float: right !important">
        <p class="user-ael">
          <span class="font-semibold">Usuario:</span>
          <span>&nbsp;</span>
          <span class="font-light"> {{ user?.email }}<br /> </span>
          <span class="font-semibold">Empresa:</span>
          <span>&nbsp;</span>
          <span class="font-light tooltip-wrapper" [matTooltip]="
              empleador?.datos_basicos?.razon_social?.length > 50
                ? empleador?.datos_basicos?.razon_social
                : null
            " matTooltipPosition="above">
            {{ truncarTexto(empleador?.datos_basicos?.razon_social, 50) }}<br />
          </span>
          <span class="font-semibold">NIT:</span>
          <span>&nbsp;</span>
          <span class="font-light">
            {{ empleador?.datos_basicos?.no_id }}<br />
          </span>
          <span class="font-semibold">Rol:</span>
          <span>&nbsp;</span>
          <span class="font-light">Afiliador<br /> </span>
        </p>
      </div>
    </div>

    <!-- Menu principal -->
    <div class="border-b-2 border-primary" *ngIf="empleadorFocunState === 2 && empleadorOnboardingState === 5">
      <div class="px-30 menu-container">
        <div class="menu-options">
          <div *ngFor="let menuItem of menu">
            <div class="menu-page" [matMenuTriggerFor]="menuRef">
              {{ menuItem.nombre }}
            </div>
            <mat-menu #menuRef="matMenu" [class]="menuItem.panelClass">
              <div *ngFor="let ruta of menuItem.rutas" (click)="irRuta(ruta.ruta)"
                (keydown)="onRutaKeydown($event, ruta.ruta)" class="menu-page-option" 
                [class.menu-page-option-faq]="ruta.className === 'menu-page-option-faq'">
                {{ ruta.nombre }}
              </div>
            </mat-menu>
          </div>
        </div>

        <div class="menu-logout">
          <notifications class="text-white"></notifications>
          <button class="menu-logout-option" type="button" (click)="signOut()">
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col justify-between items-center h-full w-full mt-[146px]">
    <div class="content-ael px-18">
      <router-outlet></router-outlet>
    </div>
          <a class="chat-btn" 
                  aria-label="Abrir chat" 
                  [href]="obtenerUrlContactanos()"
                  target="_blank" 
                  rel="noopener noreferrer">
                
            <svg class="chat-icon" viewBox="0 0 24 24">
              <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 11H6V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>
            </svg>
          </a>
    <div class="footer-ael px-30 py-10">
      <div class="container-items">
        <img class="logo-ael-blanco" src="assets/images/logo/Logo_AEL_blanco.svg" alt="logo-ael" />

        <div class="items">
          <div class="item-name">Ayuda</div>
          <a href="https://www.aportesenlinea.com/Home/Contacto.aspx?MItem=Cntct" target="_blank" class="item-option">
            Preguntas frecuentes
          </a>
        </div>

        <div class="items">
          <div class="item-name">Políticas</div>
          <a href="https://www.aportesenlinea.com/Home/LineaEtica.aspx" target="_blank" class="item-option">Línea
            ética</a>
        </div>

        <div class="items">
          <div class="item-name">Haz parte de Aportes en Línea</div>
          <a href="https://portafolio.aportesenlinea.com/trabaja-con-nosotros/" target="_blank" class="item-option">
            Trabaja con nosotros
          </a>
          <a class="item-option">Contrata con nosotros</a>
          <div class="social-medias">
            <a href="https://www.facebook.com/share/1A37QEK5u1/" target="_blank">
              <img src="assets/images/svg/facebook.svg" alt="logo-facebook" />
            </a>

            <a href="https://x.com/aportesenlinea?t=XP4lnWWcD4Yz2DA34SPrcg&s=09" target="_blank">
              <img src="assets/images/svg/twitter.svg" alt="logo-twitter" />
            </a>

            <a href="https://www.instagram.com/aportesenlinea_?igsh=bzZuczliM3hjcWxu" target="_blank">
              <img src="assets/images/svg/instagram.svg" alt="logo-instagram" />
            </a>

            <a href="https://www.linkedin.com/company/aportes-en-linea/" target="_blank">
              <img src="assets/images/svg/linkedIn.svg" alt="logo-linkedIn" />
            </a>

            <a href="https://youtube.com/@aportesenlinea?si=Ra0CFpoZItAsRaIc" target="_blank">
              <img src="assets/images/svg/youtube.svg" alt="logo-youtube" />
            </a>
          </div>
        </div>
      </div>

      <span class="item-copy">Copyright &copy; {{ currentYear }} Afiliación en Línea</span>
    </div>
  </div>
</div>